// extracted by mini-css-extract-plugin
module.exports = {"notification":"room__styles__notification___2Cf3wj","newLozenge":"room__styles__newLozenge___2A2_2X"};